<dx-popup
  #addPropertyPopup
  [width]="popupWidth"
  [height]="'auto'"
  [showTitle]="false"
  [dragEnabled]="false"
  [deferRendering]="true"
  [showCloseButton]="false"
  [shading]="true"
  [container]="'body'"
  [(visible)]="popupVisible"
  (onHiding)="checkSelection($event)"
  (onHidden)="hide()"
  (onShown)="onPopupShown()"
  [wrapperAttr]="{ class: 'add-property-modal-popup' }"
  [position]="popupPosition"
>
  <div class="add-property-modal-panel">
    <div class="add-property-modal-logout" (click)="logout()">
      <i class="fa-solid fa-sign-out-alt"></i>
      Log Out
    </div>

    <div class="add-property-modal-header">
      <div class="add-property-modal-title">
        <h2>Add Property</h2>
        <p>
          It looks like there are no properties associated with your account
          yet. Please add your first property below to get started.
        </p>
        <p class="add-property-modal-subtitle">
          If you have multiple properties, you can add additional ones later
          from your Profile menu and easily switch between them from the
          dashboard.
        </p>
      </div>
    </div>

    <div class="add-property-modal-help" (click)="onHelpClick()">
      <i class="dx-icon dx-icon-info"></i>
      <span>Where to locate my account information?</span>
    </div>

    <dx-validation-group #addPropertyValidationGroup>
      <div class="add-property-modal-form-container">
        <!-- Community ID Input -->
        <div class="add-property-input-wrapper">
          <label for="txtCommunityId" class="input-label">
            Community ID
            <span class="required-asterisk">*</span>
          </label>
          <dx-text-box
            id="txtCommunityId"
            placeholder="Community ID"
            [(value)]="accountParameterDto.intacctId"
            class="add-property-input"
          >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Community ID is required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>

        <!-- Account Number Input -->
        <div class="add-property-input-wrapper">
          <label for="txtAccountNumber" class="input-label">
            Account Number
            <span class="required-asterisk">*</span>
          </label>
          <dx-text-box
            id="txtAccountNumber"
            placeholder="Account Number"
            [(value)]="accountParameterDto.customerID"
            [maxLength]="16"
            class="add-property-input"
          >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Account Number is required"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="pattern"
                [pattern]="accountNumberPattern"
                message="Invalid Account Number"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>

        <!-- Check Digit Input -->
        <div class="add-property-input-wrapper">
          <label for="txtCheckDigit" class="input-label">
            Check Digit
            <span class="required-asterisk">*</span>
          </label>
          <dx-text-box
            id="txtCheckDigit"
            placeholder="Check Digit"
            [(value)]="accountParameterDto.checkDigit"
            class="add-property-input"
          >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Check Digit is required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>

        <!-- Add Property Button -->
        <div class="add-property-button-wrapper">
          <dx-button
            [text]="loadingVisible ? 'Adding...' : 'Add Property'"
            type="default"
            class="add-property-button"
            [disabled]="loadingVisible"
            (onClick)="addProperty()"
          ></dx-button>
        </div>
      </div>
    </dx-validation-group>
  </div>

  <dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '.add-property-modal-panel' }"
    [(visible)]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
  ></dx-load-panel>
</dx-popup>

<dx-popup
  minWidth="300px"
  minHeight="254px"
  width="50%"
  height="auto"
  [showTitle]="true"
  title="Information You Need"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="isHelpShow"
>
  <div *dxTemplate="let data of 'content'">
    <div class="add-property-modal-help-content">
      <div class="add-property-modal-help-text">
        Your Community, Account Number and Check Digit can be found on either
        your assessment payment coupon or on the "tear off" portion of your
        statement as shown below highlighted in red.
      </div>
      <div class="add-property-modal-help-image-container">
        <img [src]="helpImage" class="add-property-modal-help-image" />
      </div>
    </div>
  </div>
</dx-popup>
